import Resolver from 'ember-resolver';
import { extendResolver } from 'ember-can';
export default extendResolver(Resolver);